/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BulkPaymentResponseDto } from '../models/bulk-payment-response-dto';
import { MySettlementsResponseDto } from '../models/my-settlements-response-dto';
import { PageInfoDto } from '../models/page-info-dto';
import { settlementControllerCompleteSettlement } from '../fn/settlement/settlement-controller-complete-settlement';
import { SettlementControllerCompleteSettlement$Params } from '../fn/settlement/settlement-controller-complete-settlement';
import { settlementControllerCreate } from '../fn/settlement/settlement-controller-create';
import { SettlementControllerCreate$Params } from '../fn/settlement/settlement-controller-create';
import { settlementControllerFindById } from '../fn/settlement/settlement-controller-find-by-id';
import { SettlementControllerFindById$Params } from '../fn/settlement/settlement-controller-find-by-id';
import { settlementControllerProcessBulkPayment } from '../fn/settlement/settlement-controller-process-bulk-payment';
import { SettlementControllerProcessBulkPayment$Params } from '../fn/settlement/settlement-controller-process-bulk-payment';
import { settlementControllerProcessPayment } from '../fn/settlement/settlement-controller-process-payment';
import { SettlementControllerProcessPayment$Params } from '../fn/settlement/settlement-controller-process-payment';
import { settlementControllerSearch } from '../fn/settlement/settlement-controller-search';
import { SettlementControllerSearch$Params } from '../fn/settlement/settlement-controller-search';
import { settlementControllerSearchMySettlements } from '../fn/settlement/settlement-controller-search-my-settlements';
import { SettlementControllerSearchMySettlements$Params } from '../fn/settlement/settlement-controller-search-my-settlements';
import { settlementControllerSearchUserSettlements } from '../fn/settlement/settlement-controller-search-user-settlements';
import { SettlementControllerSearchUserSettlements$Params } from '../fn/settlement/settlement-controller-search-user-settlements';
import { settlementControllerStartSettlement } from '../fn/settlement/settlement-controller-start-settlement';
import { SettlementControllerStartSettlement$Params } from '../fn/settlement/settlement-controller-start-settlement';
import { settlementControllerUpdate } from '../fn/settlement/settlement-controller-update';
import { SettlementControllerUpdate$Params } from '../fn/settlement/settlement-controller-update';
import { SettlementDetailDto } from '../models/settlement-detail-dto';
import { SettlementDto } from '../models/settlement-dto';

@Injectable({ providedIn: 'root' })
export class SettlementService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `settlementControllerSearchMySettlements()` */
  static readonly SettlementControllerSearchMySettlementsPath = '/api/settlement/me';

  /**
   * 내 정산 내역 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settlementControllerSearchMySettlements()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerSearchMySettlements$Response(params?: SettlementControllerSearchMySettlements$Params, context?: HttpContext): Observable<StrictHttpResponse<MySettlementsResponseDto>> {
    const obs = settlementControllerSearchMySettlements(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 내 정산 내역 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settlementControllerSearchMySettlements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerSearchMySettlements(params?: SettlementControllerSearchMySettlements$Params, context?: HttpContext): Observable<MySettlementsResponseDto> {
    const resp = this.settlementControllerSearchMySettlements$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MySettlementsResponseDto>): MySettlementsResponseDto => r.body)
    );
  }

  /** Path part for operation `settlementControllerSearchUserSettlements()` */
  static readonly SettlementControllerSearchUserSettlementsPath = '/api/settlement/user/{userId}';

  /**
   * 특정 회원의 정산 상세 내역 조회 (관리자용).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settlementControllerSearchUserSettlements()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerSearchUserSettlements$Response(params: SettlementControllerSearchUserSettlements$Params, context?: HttpContext): Observable<StrictHttpResponse<MySettlementsResponseDto>> {
    const obs = settlementControllerSearchUserSettlements(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 특정 회원의 정산 상세 내역 조회 (관리자용).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settlementControllerSearchUserSettlements$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerSearchUserSettlements(params: SettlementControllerSearchUserSettlements$Params, context?: HttpContext): Observable<MySettlementsResponseDto> {
    const resp = this.settlementControllerSearchUserSettlements$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<MySettlementsResponseDto>): MySettlementsResponseDto => r.body)
    );
  }

  /** Path part for operation `settlementControllerSearch()` */
  static readonly SettlementControllerSearchPath = '/api/settlement/search/offset';

  /**
   * 정산 목록 조회 (오프셋 페이지네이션).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settlementControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerSearch$Response(params: SettlementControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<SettlementDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = settlementControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 정산 목록 조회 (오프셋 페이지네이션).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settlementControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerSearch(params: SettlementControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<SettlementDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.settlementControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<SettlementDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<SettlementDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `settlementControllerFindById()` */
  static readonly SettlementControllerFindByIdPath = '/api/settlement/{id}';

  /**
   * 정산 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settlementControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerFindById$Response(params: SettlementControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDto>> {
    const obs = settlementControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 정산 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settlementControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerFindById(params: SettlementControllerFindById$Params, context?: HttpContext): Observable<SettlementDto> {
    const resp = this.settlementControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SettlementDto>): SettlementDto => r.body)
    );
  }

  /** Path part for operation `settlementControllerUpdate()` */
  static readonly SettlementControllerUpdatePath = '/api/settlement/{id}';

  /**
   * 정산 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settlementControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settlementControllerUpdate$Response(params: SettlementControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDto>> {
    const obs = settlementControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 정산 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settlementControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settlementControllerUpdate(params: SettlementControllerUpdate$Params, context?: HttpContext): Observable<SettlementDto> {
    const resp = this.settlementControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SettlementDto>): SettlementDto => r.body)
    );
  }

  /** Path part for operation `settlementControllerCreate()` */
  static readonly SettlementControllerCreatePath = '/api/settlement';

  /**
   * 정산 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settlementControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settlementControllerCreate$Response(params: SettlementControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDto>> {
    const obs = settlementControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 정산 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settlementControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  settlementControllerCreate(params: SettlementControllerCreate$Params, context?: HttpContext): Observable<SettlementDto> {
    const resp = this.settlementControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SettlementDto>): SettlementDto => r.body)
    );
  }

  /** Path part for operation `settlementControllerStartSettlement()` */
  static readonly SettlementControllerStartSettlementPath = '/api/settlement/{id}/start';

  /**
   * 정산 진행 시작.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settlementControllerStartSettlement()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerStartSettlement$Response(params: SettlementControllerStartSettlement$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDto>> {
    const obs = settlementControllerStartSettlement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 정산 진행 시작.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settlementControllerStartSettlement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerStartSettlement(params: SettlementControllerStartSettlement$Params, context?: HttpContext): Observable<SettlementDto> {
    const resp = this.settlementControllerStartSettlement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SettlementDto>): SettlementDto => r.body)
    );
  }

  /** Path part for operation `settlementControllerCompleteSettlement()` */
  static readonly SettlementControllerCompleteSettlementPath = '/api/settlement/{id}/complete';

  /**
   * 정산 완료.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settlementControllerCompleteSettlement()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerCompleteSettlement$Response(params: SettlementControllerCompleteSettlement$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDto>> {
    const obs = settlementControllerCompleteSettlement(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 정산 완료.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settlementControllerCompleteSettlement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerCompleteSettlement(params: SettlementControllerCompleteSettlement$Params, context?: HttpContext): Observable<SettlementDto> {
    const resp = this.settlementControllerCompleteSettlement$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SettlementDto>): SettlementDto => r.body)
    );
  }

  /** Path part for operation `settlementControllerProcessPayment()` */
  static readonly SettlementControllerProcessPaymentPath = '/api/settlement/detail/{detailId}/pay';

  /**
   * 개별 지급 처리.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settlementControllerProcessPayment()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerProcessPayment$Response(params: SettlementControllerProcessPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDetailDto>> {
    const obs = settlementControllerProcessPayment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 개별 지급 처리.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settlementControllerProcessPayment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerProcessPayment(params: SettlementControllerProcessPayment$Params, context?: HttpContext): Observable<SettlementDetailDto> {
    const resp = this.settlementControllerProcessPayment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SettlementDetailDto>): SettlementDetailDto => r.body)
    );
  }

  /** Path part for operation `settlementControllerProcessBulkPayment()` */
  static readonly SettlementControllerProcessBulkPaymentPath = '/api/settlement/{id}/bulk-pay';

  /**
   * 일괄 지급 처리.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `settlementControllerProcessBulkPayment()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerProcessBulkPayment$Response(params: SettlementControllerProcessBulkPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<BulkPaymentResponseDto>> {
    const obs = settlementControllerProcessBulkPayment(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 일괄 지급 처리.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `settlementControllerProcessBulkPayment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  settlementControllerProcessBulkPayment(params: SettlementControllerProcessBulkPayment$Params, context?: HttpContext): Observable<BulkPaymentResponseDto> {
    const resp = this.settlementControllerProcessBulkPayment$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BulkPaymentResponseDto>): BulkPaymentResponseDto => r.body)
    );
  }

}
